export default async function ({ store, redirect }) {
  if (!store.state.adminAuthentication.profile) {
    await store.dispatch('adminAuthentication/loadProfile')
    if (!store.state.adminAuthentication.profile) {
      return redirect({ name: 'admin-login' })
    }
  }
}
